// const apiName = "https://exams.aspireitacademy.com/"; // Real world Api
// const apiName = "https://exam.prod-app.in/" // Testing Api
const apiName = process.env.REACT_APP_API_URL || "http://127.0.0.1:8000/";
export default apiName;